import React from "react";
import { ArrowRight, Sparkles, ShieldCheck, Plane } from "lucide-react";
import Layout from "../components/Layout";
import { AgencyLink as Link } from "../lib/agency";

export default function Landing() {
  return (
    <Layout>
      <section className="relative min-h-[calc(100dvh-4rem)] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1761078739411-2ccb6e956c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxreXJqJTIwbHV4dXJ5JTIwdHJhdmVsZXJ8ZW58MHx8fDE3Nzg2MzcxNzd8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-32">
          <div className="grid md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-7 fade-up">
              <p className="text-xs uppercase tracking-[0.4em] text-[var(--brand-cyan,#FF85AC)] mb-6">
                Viajes de Lujo · Protección Total
              </p>
              <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[1.02] mb-8">
                Cada viaje,
                <br />
                <span className="text-[var(--brand-cyan,#FF85AC)]">protegido</span> por
                <br />
                Travel Shield.
              </h1>
              <p className="text-base md:text-lg text-neutral-400 max-w-xl leading-relaxed mb-10">
                Itinerarios personalizados, chat con tu agencia y un sistema SOS de
                respuesta inmediata. Elige cómo entrar.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/login"
                  data-testid="enter-traveler-btn"
                  className="group inline-flex items-center justify-between gap-6 bg-[var(--brand-cyan,#FF85AC)] text-black px-7 py-4 rounded-full font-semibold tracking-wide hover:bg-[#FF9DC0] cyan-glow transition-all"
                >
                  <span className="flex items-center gap-3">
                    <Plane className="w-4 h-4" strokeWidth={2} />
                    Soy Viajero
                  </span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
                <Link
                  to="/promociones"
                  data-testid="enter-guest-btn"
                  className="group inline-flex items-center justify-between gap-6 bg-transparent border border-white/20 hover:bg-white/5 px-7 py-4 rounded-full font-semibold tracking-wide transition-all"
                >
                  <span className="flex items-center gap-3">
                    <Sparkles className="w-4 h-4" strokeWidth={2} />
                    Modo Invitado
                  </span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>

            <div className="md:col-span-5 hidden md:block fade-up delay-200">
              <div className="relative px-8 py-12 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md">
                <div className="flex items-center gap-2 mb-6 text-[var(--brand-cyan,#FF85AC)]">
                  <ShieldCheck className="w-5 h-5" />
                  <span className="text-sm font-semibold tracking-wider uppercase">
                    Funciones Clave
                  </span>
                </div>
                <ul className="space-y-8">
                  <li className="flex gap-4">
                    <div className="w-1.5 h-1.5 rounded-full bg-[var(--brand-cyan,#FF85AC)] relative top-2.5" />
                    <div>
                        <h4 className="font-semibold text-white mb-1">Itinerarios IA</h4>
                        <p className="text-sm text-neutral-400">
                            Auto-organizados cronológicamente desde el PDF de tu operador turístico.
                        </p>
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <div className="w-1.5 h-1.5 rounded-full bg-[var(--brand-cyan,#FF85AC)] relative top-2.5" />
                    <div>
                        <h4 className="font-semibold text-white mb-1">SOS Long-Press</h4>
                        <p className="text-sm text-neutral-400">
                          3s para enviar tu GPS al grupo y al equipo de soporte.
                        </p>
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <div className="w-1.5 h-1.5 rounded-full bg-[var(--brand-cyan,#FF85AC)] relative top-2.5" />
                    <div>
                        <h4 className="font-semibold text-white mb-1">Chat Multimodal</h4>
                        <p className="text-sm text-neutral-400">
                          Audio, video, imágenes y traducción IA con tus proveedores.
                        </p>
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <div className="w-1.5 h-1.5 rounded-full bg-[var(--brand-cyan,#FF85AC)] relative top-2.5" />
                    <div>
                        <h4 className="font-semibold text-white mb-1">Grupos de Emergencia</h4>
                        <p className="text-sm text-neutral-400">
                          Crea uno con 4+ personas y desbloquea SOS gratis.
                        </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}